import _axios from "axios";
import { AUTH_KEY } from '../consts/auth'
import { buildSignInToken, expirationFromNow } from '../sign-in/SignIn.state'
import { removeAuthStorages } from './auth'
import { getRefreshTokenInterval } from './token'

export const axios = _axios.create({
  responseType: "json",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

let promise = Promise.resolve();
const mutex = async () => promise;

window.addEventListener("storage", () => {
  const refreshing = localStorage.getItem("refreshing");
  let r;

  if (refreshing === "false" && promise.pending) {
    promise.pending = false;
    promise.resolve("refresh complete");
  }

  if (refreshing === "true" && !promise.pending) {
    promise = new Promise((resolve) => {
      r = resolve;
    });

    promise.pending = true;
    promise.resolve = r;
  }
});


axios.interceptors.request.use(async (config) => {
  if (
    promise.pending &&
    !config.url.match(/refresh.json$/) &&
    !config.url.match(/maintenance.json$/)
  ) {
    await mutex();
  }

  const tokenType = localStorage.getItem(`${AUTH_KEY}_type`);
  const token = localStorage.getItem(AUTH_KEY);

  if (tokenType && token) {
    config.headers.Authorization = `${tokenType} ${token}`;
  }

  config.headers["X-Whitelabel"] = process.env.REACT_APP_WHITELABEL;

  /**
   * Development mode will redirect requests to production (v1)
   * to staging environment,
   */
  const excludeStagingApi = [
    'https://app.socialscavenger.com/v1/upload.json',
    'https://app.socialscavenger.com/v1/medias/sign'
  ]
  if(
    (window.location.hostname === 'staging-builder.socialscavenger.com' ||
    process.env.NODE_ENV === 'development') &&
    !excludeStagingApi.find(url => config.url.match(url))
  ) {
    config.url = config.url.replace('v1', 'staging')
  }
  return config;
});

axios.interceptors.response.use(response => response, error => {
    const originalRequest = error.config;
    if (error.response.status === 401 && localStorage.getItem(`${AUTH_KEY}`)) {
        originalRequest._retry = true;

        const signUserOut = () => {
            removeAuthStorages()
            window.location = "/sign-in?expired";
        }

        const signUserIn = authState => {
            localStorage.setItem(`${AUTH_KEY}`, authState?.token)
            localStorage.setItem(`${AUTH_KEY}_refresh`, authState?.refreshToken)
            localStorage.setItem(`${AUTH_KEY}_refresh_time`, authState?.refreshTokenExpireIn)
            localStorage.setItem(`${AUTH_KEY}_state`, JSON.stringify(authState))
            localStorage.setItem(`${AUTH_KEY}_type`, authState?.tokenType)
        }

        try {
            const forceRefreshToken = async () => {
                const auth = JSON.parse(localStorage.getItem(`${AUTH_KEY}_state`))
                if (
                    // make sure the user is logged in
                    auth?.user_id && 
                    // only execute when the token will be expired before the existing refresh token interval kicks in
                    expirationFromNow(auth?.token) < getRefreshTokenInterval(auth?.lifespan) && 
                    // only execute when it has refresh token.
                    auth?.refresh_token && 
                    // do not retry failed refresh token
                    !originalRequest.url.match(/refresh.json$/)
                ) {
                    try {
                        const response = await axios.post(process.env.REACT_APP_API_REFRESH_URL,
                            { 'refresh_token': auth?.refresh_token },
                            {
                                headers: {
                                    'Authorization': `Bearer ${auth?.token}`
                                }
                            }
                        )
                        if (response) {
                            const newAuthState = buildSignInToken(response.data, auth?.user_id)
                            signUserIn(newAuthState)
                            axios.defaults.headers.common['Authorization'] = 'Bearer ' + response?.data?.token;
                            axios.request(originalRequest)
                        } else {
                            console.debug(`Refresh token request failed. Response: `, response)
                            signUserOut()
                        }
                    } catch (e) {
                        console.debug(`Refresh token request failed. Error: `, e)
                        signUserOut()
                    }
                } else {
                    if (!originalRequest.url.match(/refresh.json$/)) {
                        if (!auth?.user || !auth.refresh_token) {
                            console.debug(`User is already logged out. System is not able to refresh token.`)
                            console.debug(`Current auth object: `, auth)
                        }
                    } else {
                        console.debug(`Refresh token request failed. Token: `, auth.refresh_token)
                        signUserOut()
                    }
                }
            }
            forceRefreshToken()
        } catch (e) {
            console.debug('Error intercepting 401 response', e)
        }
    } else {
        return Promise.reject(error);
    }
})